export default __webpack_public_path__ + "static/media/pencil.e51fc9e6.svg";